import { createModel } from "~~/package/utils/ModelUtil";
import Model from "~~/package/mapper/Model";
import {CautionType} from '~~/package/types/CautionType';
import {ViolationGradeType} from '~~/package/mapper/report/model/ViolationGradeType';

export class CandidateActionAnalysisModel extends Model {
    constructor(
        public actionAnalysisInformation: ActionAnalysisInformation = new ActionAnalysisInformation(),
        public actionDetails: ActionDetails = new ActionDetails()
    ) {
        super();
    }

    public static create(model: Partial<CandidateActionAnalysisModel>): CandidateActionAnalysisModel {
        return createModel<CandidateActionAnalysisModel>(CandidateActionAnalysisModel, {
            ...model
        });
    }
}

export class ActionAnalysisInformation {
    constructor(
        public currentGrade: ViolationGradeType = ViolationGradeType.CLEAN,
        public reason: string = ""
    ) {}
}

export class ActionDetails {
    constructor(
        public actions: ActionItem[] = []
    ) {}
}

export class ActionItem {
    constructor(
        public action: CautionType = CautionType.TAB_SWITCH,
        public actionDateAt: string = "",
        public actionContent: string = "",
        public actionRecordUrl: string = "",
        public suspiciousFlag: boolean = false
    ) {}
}
